







































import * as _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { OpenGraphGender, OpenGraphProfile } from '@/modules/seo/types'
import { Prop } from 'vue-property-decorator'

@Component
export default class ProfileEditor extends Vue {

  @Prop() public value: OpenGraphProfile

  @Prop({type: Boolean, default: false})
  public disabled: boolean

  public genders = [
    { value: OpenGraphGender.Female, name: 'Femenino' },
    { value: OpenGraphGender.Male, name: 'Masculino' },

    // Este género no esta especificado por el protocolo, pero me parece
    // bien añadirlo
    { value: OpenGraphGender.Other, name: 'Otro género' },
  ];

  get profile (): OpenGraphProfile {
    return _.clone(this.value) || new OpenGraphProfile()
  }

  public update (field: string, value: string) {
    this.$emit('input', _.set(this.profile, field, value))
  }
}
